import { render, staticRenderFns } from "./Participant.vue?vue&type=template&id=19641000&scoped=true&"
import script from "./Participant.vue?vue&type=script&lang=js&"
export * from "./Participant.vue?vue&type=script&lang=js&"
import style0 from "./Participant.vue?vue&type=style&index=0&id=19641000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19641000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19641000')) {
      api.createRecord('19641000', component.options)
    } else {
      api.reload('19641000', component.options)
    }
    module.hot.accept("./Participant.vue?vue&type=template&id=19641000&scoped=true&", function () {
      api.rerender('19641000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/Participant.vue"
export default component.exports